import { gql, TypedDocumentNode } from "@apollo/client";
import { PAGE_INFO_FRAGMENT } from "@/hooks/usePagination";
import { PageInfo, PaginationVariables } from "@/components/Pagination";
import type { CareerConsultantAssignment, CoverageSection } from "./types";

export type SectionConsultantAssignmentsQueryResponse = {
  sectionConsultantAssignments: {
    nodes: CareerConsultantAssignment[];
    pageInfo: PageInfo;
    totalCount: number;
  };
};

export type SectionConsultantAssignmentsQueryVariables = PaginationVariables & {
  search?: string;
  isActive?: boolean | null;
  sectionId?: string;
  backofficeUserId?: string;
};

export const SECTION_CONSULTANT_ASSIGNMENTS_QUERY: TypedDocumentNode<
  SectionConsultantAssignmentsQueryResponse,
  SectionConsultantAssignmentsQueryVariables
> = gql`
  query SectionConsultantAssignments(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $search: String
    $isActive: Boolean = true
    $sectionId: ID
    $backofficeUserId: ID
  ) {
    sectionConsultantAssignments(
      first: $first
      last: $last
      before: $before
      after: $after
      search: $search
      isActive: $isActive
      sectionId: $sectionId
      backofficeUserId: $backofficeUserId
    ) {
      nodes {
        id
        isActive
        section {
          id
          name
        }
        consultant {
          id
          name
          email
        }
      }
      ...PageInfo
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;

export type ConfigurationSectionsQueryResponse = {
  crmSections: {
    nodes: CoverageSection[];
    pageInfo: PageInfo;
    totalCount: number;
  };
};

export type ConfigurationSectionsQueryVariables = PaginationVariables & {
  input?: {
    search?: string;
  };
};

export const CONFIGURATION_SECTIONS_QUERY: TypedDocumentNode<
  ConfigurationSectionsQueryResponse,
  ConfigurationSectionsQueryVariables
> = gql`
  query ConfigurationSections(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $input: BackofficeCRMSectionsInput
  ) {
    crmSections(first: $first, last: $last, before: $before, after: $after, input: $input) {
      nodes {
        id
        name
        recruiter {
          id
          name
          email
        }
        playerEngagementConsultant {
          id
          name
          email
        }
        sectionOffice {
          mainAddress {
            city
            state
          }
        }
      }
      ...PageInfo
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;

export type ConfigurationSectionOptionsQueryResponse = {
  crmSections: {
    nodes: CoverageSection[];
  };
};

export type ConfigurationSectionOptionsQueryVariables = {
  first?: number;
};

export const CONFIGURATION_SECTION_OPTIONS_QUERY: TypedDocumentNode<
  ConfigurationSectionOptionsQueryResponse,
  ConfigurationSectionOptionsQueryVariables
> = gql`
  query ConfigurationSectionOptions($first: Int) {
    crmSections(first: $first) {
      nodes {
        id
        name
        recruiter {
          id
          name
          email
        }
        playerEngagementConsultant {
          id
          name
          email
        }
      }
    }
  }
`;
